package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SavedView(
    val id: String,
    val name: String,
    @SerialName("filter_query") val filterQuery: String,
    @SerialName("created_at") val createdAt: String,
)

@Serializable
data class SavedViewsResponse(val views: List<SavedView>)

@Serializable
data class SavedViewsRequest(val views: List<SavedView>)
